// Service Worker registration for PWA support

export function registerSW() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('[SW] Registered:', registration.scope);
          
          // Handle updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New content available - notify user
                  console.log('[SW] New content available');
                  // Could dispatch an event to show "Update Available" UI
                  window.dispatchEvent(new CustomEvent('sw-update-available'));
                }
              });
            }
          });
        })
        .catch((error) => {
          console.error('[SW] Registration failed:', error);
        });
    });
    
    // Listen for messages from service worker
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data.type === 'SYNC_NOVELS') {
        // Trigger sync when back online
        window.dispatchEvent(new CustomEvent('sync-novels'));
      }
    });
  }
}

// Request background sync permission
export async function requestBackgroundSync() {
  if ('serviceWorker' in navigator && 'SyncManager' in window) {
    const registration = await navigator.serviceWorker.ready;
    try {
      await (registration as any).sync.register('sync-novels');
      console.log('[SW] Background sync registered');
    } catch (err) {
      console.error('[SW] Background sync failed:', err);
    }
  }
}

// Check if app is installed
export function isStandalone(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone === true
  );
}

// Prompt for app install
export function promptInstall(): Promise<boolean> {
  return new Promise((resolve) => {
    let deferredPrompt: any;
    
    const handler = (e: Event) => {
      e.preventDefault();
      deferredPrompt = e;
      
      // Show install prompt
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult: { outcome: string }) => {
        resolve(choiceResult.outcome === 'accepted');
        deferredPrompt = null;
        window.removeEventListener('beforeinstallprompt', handler);
      });
    };
    
    window.addEventListener('beforeinstallprompt', handler);
    
    // Timeout if no prompt available
    setTimeout(() => {
      if (!deferredPrompt) {
        resolve(false);
        window.removeEventListener('beforeinstallprompt', handler);
      }
    }, 1000);
  });
}
